/**
 * Possible Gutenberg context
 *
 * Often useful to determine different selectors.
 */
export type GutenbergContext = 'post-editor' | 'site-editor';
